import { CALLOUT_ATTRIBUTE, CALLOUT_SELECTOR } from '../constants/hscallout';
export function getCalloutType(editor, target) {
  return target && editor.dom.getAttrib(target, CALLOUT_ATTRIBUTE);
}
export function getParentCallout(editor, target) {
  const parent = editor.dom.getParent(target, CALLOUT_SELECTOR, editor.getBody());
  return parent;
}